<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novi"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedGrad"
      (onClick)="onEditClick()">
    </dx-button>
    
    <dx-button
      icon="trash"
      text="Obriši"
      type="danger"
      [disabled]="!selectedGrad"
      (onClick)="onDeleteClick()">
    </dx-button>
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #gradoviGrid
    id="gradoviGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onGradRowClick($event)">
    
    <dxi-column 
      dataField="grad1" 
      caption="Grad" 
      [minWidth]="200"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="broj_poste" 
      caption="Broj pošte" 
      [width]="120"
      dataType="number"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novi Grad"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="gradForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="grad1"
          placeholder="Unesite naziv grada"
          [isValid]="!gradForm.get('grad1')?.errors"
          validationMessage="Naziv grada je obavezan">
        </dx-text-box>
        
        <dx-number-box
          formControlName="broj_poste"
          placeholder="Unesite broj pošte"
          [min]="1"
          [showSpinButtons]="true"
          [isValid]="!gradForm.get('broj_poste')?.errors"
          validationMessage="Broj pošte je obavezan i mora biti pozitivan broj">
        </dx-number-box>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createGrad()"
          [disabled]="!gradForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Izmijeni Grad"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="gradForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="grad1"
          placeholder="Unesite naziv grada"
          [isValid]="!gradForm.get('grad1')?.errors"
          validationMessage="Naziv grada je obavezan">
        </dx-text-box>
        
        <dx-number-box
          formControlName="broj_poste"
          placeholder="Unesite broj pošte"
          [min]="1"
          [showSpinButtons]="true"
          [isValid]="!gradForm.get('broj_poste')?.errors"
          validationMessage="Broj pošte je obavezan i mora biti pozitivan broj">
        </dx-number-box>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Ažuriraj"
          type="default"
          (onClick)="updateGrad()"
          [disabled]="!gradForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>